var _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgColorPalette(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.18555 18.0002C3.18555 19.9335 4.75203 21.5 6.68533 21.5C8.61863 21.5 10.1851 19.9335 10.1851 18.0002V6.99978C10.1851 5.06649 8.61863 3.5 6.68533 3.5C4.75203 3.5 3.18555 5.06649 3.18555 6.99978V18.0002Z",
    stroke: "#000000",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.16016 20.4763L17.8109 11.8266C19.1769 10.4596 19.1769 8.24313 17.8109 6.8761C16.4438 5.51005 14.2274 5.51005 12.8604 6.8761L10.1857 9.55178",
    stroke: "#000000",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.68555 21.4999L17.6856 21.4996C19.6189 21.4996 21.1854 19.9331 21.1854 17.9998C21.1854 16.0665 19.6189 14.5 17.6856 14.5H15.1355",
    stroke: "#000000",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6.68603 18.0425V18.0793M6.83517 18.0504C6.83517 18.1332 6.76796 18.2004 6.68512 18.2004C6.60228 18.2004 6.53516 18.1332 6.53516 18.0504C6.53516 17.9675 6.60228 17.9004 6.68512 17.9004C6.76796 17.9004 6.83517 17.9675 6.83517 18.0504Z",
    stroke: "#000000",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgColorPalette);
export default __webpack_public_path__ + "static/media/ColorPalette.93963b11fb16f21c29eced03f4397e31.svg";
export { ForwardRef as ReactComponent };